export var FRESHCHAT_HOST = 'https://wchat.freshchat.com';
export var FRESHCHAT_WIDGET_PATH = 'js/widget.js';
export var FRESHCHAT_WIDGET_URL = FRESHCHAT_HOST + "/" + FRESHCHAT_WIDGET_PATH;
export var FRESHCHAT_WIDGET_CLASS = 'mt-fc_frame';
export var LOGGER_NAME = 'freshchat';
export var FRESHCHAT_WIDGET_ID_FOR_BERRY = '77ee8384-38cd-43f9-b417-ec3528142076';
export var FRESHCHAT_EVENT_NAME = {
    WIDGET_USER_CREATED: 'user:created',
    WIDGET_CLOSED: 'widget:closed',
    WIDGET_CSAT_RECEIVED: 'csat:received',
    WIDGET_CSAT_UPDATED: 'csat:updated',
    WIDGET_LOADED: 'widget:loaded',
    WIDGET_CONVERSATION_RESOLVED: 'conversation:resolved',
    WIDGET_MESSAGE_SENT: 'message:sent',
    WIDGET_MESSAGE_RECEIVED: 'message:received',
};
export var MESSAGES = {
    CSAT_REPLY_PLACEHOLDER: 'Type here...',
    CSAT_QUESTION: 'Were you satisfied with our help?',
    REPLY_FIELD_PLACEHOLDER: 'Pro tip: detailed prompts unlock my full potential to help you.',
};
//# sourceMappingURL=constants.js.map